module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"rehypePlugins":[null],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-mermaid","options":{"language":"mermaid","theme":"neutral"}},{"resolve":"gatsby-remark-images","options":{"maxWidth":800}},{"resolve":"gatsby-remark-vscode","options":{"languageAliases":{"curl":"bash"},"theme":{"default":"Light+ (default light)"}}}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/builds/ifood/restaurant/merchant-platform/developer-portal-front/src/locales","languages":["en-US","pt-BR","es-CO"],"defaultLanguage":"pt-BR","redirect":true,"redirectComponent":"../../src/redirect.tsx"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
